import { render, staticRenderFns } from "./IRListItems.vue?vue&type=template&id=61b2b318&scoped=true&"
import script from "./IRListItems.vue?vue&type=script&lang=js&"
export * from "./IRListItems.vue?vue&type=script&lang=js&"
import style0 from "./IRListItems.vue?vue&type=style&index=0&id=61b2b318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b2b318",
  null
  
)

export default component.exports